import { UtenteDTO } from "./utenteDTO";

export class VisibilitaAttoDTO {
    dataInizioVisibilita: string;
    dataFineVisibilita: string;
    operatore: UtenteDTO;
    utente: UtenteDTO;
}